<template>
  <div class="column is-12">
    <div class="box">
      <div class="columns">
        <div class="column is-12">
          <strong>{{ elLabel }}</strong>

          <a class="icon is-info is-large is-pulled-right" @click="$emit('sectionWasAdded')">
            <i class="fa fa-plus-circle fa-2x"></i>
          </a>

        </div>
      </div>
      <draggable v-model="n" :options="{draggable:'.sections', handle:'.my-handle'}" class="columns is-multiline">
        <div class="column is-12 sections" v-for="(i, index) in n" :key="i.id">
          <div class="box" style="background-color: #f9f9f9;">
            <div class="columns is-variable is-1 is-multiline">
              <div class="column is-12">

                <!-- move item -->
                <a class="is-pulled-right icon my-handle" style="margin-left:30px;">
                  <i class="fa fa-arrows"></i>
                </a>

                <!-- delete section -->
                <a class="is-pulled-right" @click="$emit('sectionWasRemoved', index)">
                  Section löschen
                </a>
  

                <div class="field is-horizontal">
                  <div class="field-body">
                    <div class="field is-narrow">
                      <div class="control">
                        <input class="is-checkradio is-circle is-small" :id="i.id" type="checkbox" :name="i.id" :checked="i.fullwidth" @click="$emit('fullwidthChanged', index)">
                        <label :for="i.id">Gesamte Breite</label>
                      </div>
                    </div>
                    <div class="field is-narrow">
                      <div class="control">
                        <div class="select is-fullwidth is-small">
                          <select class="select" v-model="i.size">
                            <option disabled>Höhe</option>
                            <option value="auto"> Auto</option>
                            <option value="is-medium"> Medium</option>
                            <option value="is-large"> Large</option>
                            <option value="is-fullheight"> Full</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="field is-narrow">
                      <div class="control">
                        <div class="select is-fullwidth is-small">
                          <select class="select" v-model="i.style">
                            <option disabled>Styling</option>
                            <option value="is-white"> Weiß</option>
                            <option value="is-primary"> Dunkelgrün</option>
                            <option value="is-secondary"> Hellgrün</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="column is-6">
                <div class="field">
                  <div class="control has-icons-right">
                    <input 
                    maxlength="500"
                    placeholder="Überschrift" 
                    :class="{'input': true, 'is-small': true, 'is-danger': errors.has('headline' + i.id) }" 
                    type="text" 
                    v-validate="'required'" 
                    v-model="i.headline"
                    :name="'headline' + i.id">
                    <span v-show="errors.has('headline' + i.id)" class="icon is-small is-right">
                      <i class="fa fa-warning"></i>
                    </span>
                  </div>
                </div>
              </div>





              <div class="column is-6">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="1500"
                    placeholder="Untertitel" 
                    class="input is-small" 
                    type="text" 
                    v-model="i.subtitle">
                  </div>
                </div>
              </div>

              <div class="column is-12">

                <div class="columns is-variable is-1">

                  <div class="column" v-for="(item, index1) in i.columns" :key="index1">
                    <div class="box">

                      <!-- delete this column -->
                      <a class="icon is-dark is-pulled-right" v-if="i.columns.length>1" @click="$emit('columnWasRemoved', { section: index, column: index1 })">
                        <i class="fa fa-minus"></i>
                      </a>
                      <!-- / delete column -->

                      <div class="field">
                          <img v-if="!item.image.path.length" src="../../../assets/img.png" style="max-width: 100px; max-height: 100px;"
                          @click="$emit('showImageSelector', { target: propName, parent: index, child: index1 })">
                          <img v-else :src="assetsBaseUrl + item.image.path" style="width: 100px;"
                          @click="$emit('removeImage', { parent: index, child: index1 })">
                      </div>

                      <div class="field">
                        <label class="label is-small">Kolumne</label>
                        <div class="control">
                          <input 
                          maxlength="500"
                          class="input is-small" 
                          type="text" 
                          placeholder="Headline" 
                          v-model="item.headline">
                        </div>
                      </div>

                      <div class="field">
                        <div class="control">
                          <p :class="{ 'control': true, 'has-icon': true, 'has-icon-right': true }">
                            <textarea 
                            maxlength="5000"  
                            rows="4" 
                            v-model="item.text"
                            v-validate="'required'" 
                            :class="{'textarea': true, 'is-small': true, 'is-danger': errors.has('ct' + index1) }" 
                            :name="'ct' + index1" 
                            :id="'ct' + index1" 
                            placeholder="Text"></textarea>
                            <span v-show="errors.has('ct' + index1)" class="icon is-small"><i class="fa fa-warning"></i></span>
                          </p>
                        </div>
                      </div>

                      <div class="field">
                                            <div class="control">
                      <input
                      class="input is-small"
                      v-model="item.link"
                      placeholder="/relativer/pfad">

                    </div></div>
                                          <div class="field">
                                            <div class="control">

                      <input
                      class="input is-small"
                      v-model="item.linktext"
                      placeholder="Button Text">
                    </div>
                      </div>

                                          <div class="field is-narrow">
                      <div class="control">
                        <input class="is-checkradio is-circle is-small" :id="'cb' + index + index1" type="checkbox" v-model="item.linkExternal">
                        <label :for="'cb' + index + index1">Neues Fenster</label>
                      </div>
                    </div>

                    </div>

                  </div>
                </div>

              </div>

              <div class="column is-12" v-if="i.columns.length<4">
                <a @click="$emit('columnWasAdded', index)">
                  <span class="icon"><i class="fa fa-plus"></i></span> Zusätzliche Kolumne
                </a>
              </div>



            </div>

          </div>
        </div>
      </draggable>


    </div>


  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  inject: ['$validator'],
  props: ['data', 'elLabel', 'propName'],
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    draggable
  },
  computed: {
    n: {
      get () {
        return this.data
      },
      set (value) {
        this.$emit('wasSorted', value)
      }
    },
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Sections.vue